import { Component, h } from 'preact';
import { PreactHTMLConverter } from 'preact-html-converter';

import { sort_candidates_by_party } from '../election-utils';

import cx from 'classnames';

import text from '../../../data/text.json';

const converter = PreactHTMLConverter();

import {
  get_directory_slug,
} from '../election-utils';

type Props = {
  contest: { [key: string]: any };
  columnCount: number;
  notes: { [key: string]: any };
  tableHeader: JSX.Element;
  contestTitle: string;
  contestOffice: string;
  renderCandidate: any;
  visibleCandidatesCount?: number;
};

class Contest extends Component<Props> {
  render() {
    const {
      contest,
      contestTitle,
      contestOffice,
      renderCandidate,
      notes,
      tableHeader,
    } = this.props;

    let candidates = sort_candidates_by_party(contest.candidacies);

    const IsUnopposedState = candidates.length == 1 && contest.office != 'U.S. House' ? true : false;

    const IsNoted = notes && notes.length > 0 ? true : false;

    let directory_slug;

    if (contest) {
      directory_slug = get_directory_slug(contest.office);
    }

    let raceClass = cx('seat__race', {
      'special-election': contest.election_type == 'special',
      'general-seat-before-special': (contest.office_slug == 'us-house-district-18') || (contest.office_slug == 'texas-house-district-56'),
    })

    let seatClass = cx('seat',  {
      'special-election__grid': contest.election_type == 'special',
    })
    
    

    return (
      <div class={seatClass}>
        <div class={raceClass}>
          <div class="race">
            <h3 class="seat__title">
              {contestOffice != null && (
                <h2 class="office__title">{contestOffice}</h2>
              )}

              <span>{contest.election_type == 'special' && (
                <div class="special-election__title">Special Election</div>
              )}{contestTitle}</span>
                {directory_slug[0] != null && (
              <a class="t-links-unset"
                href={`https://www.texastribune.org/directory/districts/${directory_slug[0]['directory-slug']}/${contest['office_division']}`}
              >
                <span class="icon-div" title="Click to learn more about this district">
                  <svg class="icon icon-info">
                    <use xlinkHref="#icon-info"></use>
                  </svg>
                </span>
              </a>
            )}
            {/* {contest.office_slug == 'state-board-of-education-district-13' && (
                <span class="no-break"> - Unexpired Term</span>
              )} */}
            </h3>

            <table class="race__candidates">
              {tableHeader}
              <tbody>
                {candidates.map((candidate: any, idx: any) =>
                  renderCandidate(candidate, idx)
                )}
              </tbody>
            </table>
          </div>
          {IsNoted == true && (
            <p class="note__text t-wrap-balance">
              {converter.convert(notes[0].value)}
            </p>
          )}
           {/* {IsUnopposedState == true && (
            <p class="note__text t-wrap-balance">
             {IsNoted == false ? 'Note:' : '' } {converter.convert(text['uncontested-races'])}
            </p>
          )} */}
        </div>
      </div>
    );
  }
}

Contest.defaultProps = {
  isShowcaseRace: false,
  includeCountyRundown: false,
  visibleCandidatesCount: 3,
};

export default Contest;